module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAOCAYAAAAi2ky3AAAAhklEQVQoka2Syw2AIBAFB0ITlmQdWgiN2IbWYCF+usADatDguiRMwuVBJrvkmQlaYAAaZDagA6Y0nL0HwColnG+Gr0urlKSyT1EVLHF3Lbsk6qUHCQvxs7M4YCTuHs7M6Ad8TlQFk5TiPVFRvyTRqpDcMpcJQyb7o6naowvzOkX9kiYq6tcBpXcaigr0mv0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/add02.png
// module id = 6bBo
// module chunks = 1